import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {  Typography} from '@material-ui/core' 
import { getDatatype } from '../store/actions/CommonAction';
import { TimeoutLogic } from "../utils/TimeoutLogic";
import McPreferences from '../Component/Dialogs/McPreferences';
import { ToastContainer, toast } from 'react-toastify';


const DataTypeList = (props) => {
    const dispatch = useDispatch();
   
    const getDatatypeList = useSelector(state => state.common.getDatatypeList)
    const getProductTheme = useSelector(state => state.common.getProductTheme)

    const [openMcPreferences, setOpenMcPreferences] = useState(false);
  const [values, setValues] = useState({
      select1: '',
      select2: '',
  });

    const callAPI = async() =>{
        await dispatch(getDatatype())
    }
  //   const applyTheme = ()=>{
  //     document.getElementById("menuBar").style.setProperty('background-color', getProductTheme.theme, 'important');
        
  //       const consentCard = document.getElementsByClassName("consent-card");
  //       for (let i = 0; i < consentCard.length; i++) {
  //         consentCard[i].style.setProperty('border-top','4px solid '+getProductTheme.theme, 'important')
  //       }
  
  //       const cardHeader = document.getElementsByClassName("card-header");
  //       for (let i = 0; i < cardHeader.length; i++) {
  //         cardHeader[i].style.setProperty('color',getProductTheme.theme, 'important')
  //       }
     
  //       const dashboardCard = document.getElementsByClassName("dashboard-card");
  //       for (let i = 0; i < dashboardCard.length; i++) {
  //         dashboardCard[i].style.setProperty('border-top','4px solid '+getProductTheme.theme, 'important')
  //       }

  
  //       const th = document.getElementsByTagName("th");
  //       for (let i = 0; i < th.length; i++) {
  //         th[i].style.setProperty('color', getProductTheme.theme, 'important')
  //       }
  
  // }
// eslint-disable-next-line
    useEffect(() => {
      if(!sessionStorage.getItem('sessionId')){
        toast.error(`Your Session has Expired: Please login again`);
        window.location.href = '/login';
    }
      callAPI(); 
     // applyTheme();
      console.log("calling get api ",typeof(getDatatypeList) )  }, [])


      useEffect(() => {
        // Add body class when component mounts
        document.body.classList.add('manage');
        // Remove body class when component unmounts
        return () => {
          document.body.classList.remove('manage');
        };
      }, []);

  
   
    return (   
       <>
           
            {/* <section className='content-header'>
              <div className='container'>
                <div className='row align-items-center'>
                  <div className='col-md-12'>
                    <h1 className='page-title'>
                      Data Type<br></br>
                      <span>List of Data Types.</span>
                    </h1>
                  </div>
                </div>
              </div>
            </section> */}

        { 
            getDatatypeList && getDatatypeList.length === 0  ?
            <div className="" >
                <Typography align="center" style={{ fontSize:20}}>No data types available. </Typography>
            </div>
        :
        <section className='content h-100'>
        <div className='container' style={{marginTop:'10%', marginBottom:'2%'}}>
          <div className='row'>
            <div className='col-md-12'>
              <div class="card custom-cards">
                <div class="card-body">
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='table-responsive'>
                        <table class='table'>
                          <thead>
                            <tr>
                              <th scope='col'>S. No.</th>
                              <th scope='col'>Data Type</th>
                              <th scope='col'>Data Category</th>
                            </tr>
                          </thead>
                          <tbody>
                          {getDatatypeList && getDatatypeList.length > 0 ? (
                            getDatatypeList.map((element, key)=> (
                              <tr key={key}>
                              <td>{key+1}</td>
                              <td >{element.dataType}</td>
                              <td>
                                {element.consentType && (
                                  <div>
                                    {element.consentType.map((ele, i) => (
                                      <div key={i}>
                                        {ele}
                                        {element.consentType.length - 1 === i ? '' : ','}
                                      </div>
                                    ))}
                                    <br></br>
                                  </div>
                                )}
                              </td>
                            </tr>
                            ))
                            
                          ) :
                          (
                            <tr>
                            <td>No data available</td>
                          </tr>
                          )
                          }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-2 justify-content-between'>
                  <div className='col-md-auto me-auto '>
                      {getDatatypeList &&
                        getDatatypeList.length > 0 ? (
                          <div className="dt-info">
                            Showing 1 to {getDatatypeList.length} entries of {getDatatypeList.length} entries
                          </div>
                        ) : (
                          <div>
                            {getDatatypeList && getDatatypeList 
                              ? `${getDatatypeList.length} entries present`
                              : "No entries present"}
                          </div>
                        )}
                  </div>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        




        }
     <McPreferences
        open={openMcPreferences}
        onClose={() => setOpenMcPreferences(false)}
      />
       

         
           
    
        <TimeoutLogic/> 
  </>
   
           
     )
}

export default DataTypeList




//   { getDatatypeList &&  
//     getDatatypeList.map((ele, key) => ( 

//     <div key={key} className="innerItem m-2 p-2 " style={{display:'flex',justifyContent:'space-between'}}>   
//         <div>
//             <div>
//                 <span>Data type: </span>   <span style={{fontWeight:"bold"}}>{ele.dataType}   </span>  
//                 {/* <span>  Client Id : </span>   <span style={{fontWeight:"bold"}}>{ele.clientId}   </span>  */}

//             </div>
//             <div>
//                 <span>Data Category:</span>   <span style={{fontWeight:"bold"}}>
//                         {ele.consentType &&
//                             ele.consentType.map((element,key)=> (
//                             <>{element}{ (ele.consentType.length)-1 === key ? '' : ', '}</> 
//                         ))}
//                      </span> 
//             </div>
//         </div>        
       
//     </div>
//     ))
//     }